import React from 'react';
import classnames from 'classnames';
import { NeuroMessage } from '@ignitesales/neuro-application';
import { analyticEvents } from '../../utils/analytics';

const LandingPage = ({ className, location, onStartGuideClick, processingNavigation }) => {
  const pageCssBEM = 'landingPage';
  const classes = classnames(pageCssBEM, className);

  const startGuide = () => {
    onStartGuideClick('checking', location);
  };

  return (
    <>
      <div className={classes}>
        <div className={ `${ pageCssBEM }__container` }>
          <div className={ `${ pageCssBEM }__content` }>
            <NeuroMessage id="landing.title" tagName="h1" />
            <NeuroMessage id="landing.subtitle" tagName="p" />
            <button type="button" className="btn landingPage__button" onClick={startGuide} disabled={processingNavigation}>
              <NeuroMessage id="landing.getStarted" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
